var BxfBadgeStyleEnum;
(function (BxfBadgeStyleEnum) {
    BxfBadgeStyleEnum["NEUTRAL"] = "neutral";
    BxfBadgeStyleEnum["ALERT"] = "alert";
    BxfBadgeStyleEnum["ERROR"] = "error";
    BxfBadgeStyleEnum["WARNING"] = "warning";
    BxfBadgeStyleEnum["SUCCESS"] = "success";
    BxfBadgeStyleEnum["NEW"] = "new";
    BxfBadgeStyleEnum["IN_PROGRESS"] = "in_progress";
})(BxfBadgeStyleEnum || (BxfBadgeStyleEnum = {}));

export { BxfBadgeStyleEnum as B };
